import { PreAssessedFee } from '../types';

const generatePreAssessedFee = (
  id: number,
  studentId: string,
  feeId: string,
  pricingTier: 'full' | 'reduced' | 'free',
  status: 'pending' | 'paid' | 'overdue' | 'cancelled' = 'pending',
  quantity: number = 1,
  amountPaid?: number
): PreAssessedFee => ({
  id: `950e8400-e29b-41d4-a716-${String(446655440000 + id).padStart(12, '0')}`,
  studentId,
  feeId,
  quantity,
  dueDate: new Date('2026-03-15'),
  status,
  pricingTier,
  amountPaid,
  createdAt: new Date('2025-08-15'),
});

export const mockPreAssessedFees: PreAssessedFee[] = [
  {
    id: '950e8400-e29b-41d4-a716-446655440001',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440003',
    quantity: 1,
    dueDate: new Date('2024-09-15'),
    status: 'pending',
    pricingTier: 'full',
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440002',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440011',
    quantity: 2,
    dueDate: new Date('2024-09-01'),
    status: 'pending',
    pricingTier: 'full',
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440003',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440001',
    quantity: 1,
    dueDate: new Date('2024-09-30'),
    status: 'pending',
    pricingTier: 'reduced',
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440004',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440004',
    quantity: 1,
    dueDate: new Date('2024-09-15'),
    status: 'pending',
    pricingTier: 'reduced',
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440005',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    feeId: '850e8400-e29b-41d4-a716-446655440003',
    quantity: 1,
    dueDate: new Date('2024-09-15'),
    status: 'pending',
    pricingTier: 'free',
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440006',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    feeId: '850e8400-e29b-41d4-a716-446655440011',
    quantity: 1,
    dueDate: new Date('2024-09-01'),
    status: 'pending',
    pricingTier: 'free',
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440007',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    feeId: '850e8400-e29b-41d4-a716-446655440005',
    quantity: 1,
    dueDate: new Date('2024-09-15'),
    status: 'pending',
    pricingTier: 'full',
    amountPaid: 50.00,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440008',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    feeId: '850e8400-e29b-41d4-a716-446655440010',
    quantity: 1,
    dueDate: new Date('2025-03-31'),
    status: 'pending',
    pricingTier: 'reduced',
    amountPaid: 15.00,
    createdAt: new Date('2024-09-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440009',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440006',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'full',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440010',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440008',
    quantity: 3,
    dueDate: new Date('2026-03-10'),
    status: 'pending',
    pricingTier: 'full',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440011',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440012',
    quantity: 1,
    dueDate: new Date('2024-08-31'),
    status: 'pending',
    pricingTier: 'reduced',
    amountPaid: 25.00,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440012',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440002',
    quantity: 2,
    dueDate: new Date('2024-12-31'),
    status: 'pending',
    pricingTier: 'full',
    amountPaid: 225.00,
    createdAt: new Date('2024-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440013',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440016',
    quantity: 1,
    dueDate: new Date('2026-03-20'),
    status: 'pending',
    pricingTier: 'reduced',
    amountPaid: 20.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440014',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    feeId: '850e8400-e29b-41d4-a716-446655440017',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'free',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440015',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    feeId: '850e8400-e29b-41d4-a716-446655440019',
    quantity: 1,
    dueDate: new Date('2026-03-25'),
    status: 'pending',
    pricingTier: 'full',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440016',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    feeId: '850e8400-e29b-41d4-a716-446655440020',
    quantity: 1,
    dueDate: new Date('2026-03-30'),
    status: 'pending',
    pricingTier: 'reduced',
    amountPaid: 30.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440017',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440007',
    quantity: 1,
    dueDate: new Date('2026-03-28'),
    status: 'pending',
    pricingTier: 'full',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440018',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440022',
    quantity: 1,
    dueDate: new Date('2024-09-15'),
    status: 'paid',
    pricingTier: 'full',
    amountPaid: 42.00,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440019',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440022',
    quantity: 1,
    dueDate: new Date('2024-09-15'),
    status: 'paid',
    pricingTier: 'reduced',
    amountPaid: 21.00,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440020',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    feeId: '850e8400-e29b-41d4-a716-446655440023',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'free',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440021',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    feeId: '850e8400-e29b-41d4-a716-446655440023',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'full',
    amountPaid: 24.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440022',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440036',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'full',
    amountPaid: 15.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440023',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440036',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'reduced',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440024',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    feeId: '850e8400-e29b-41d4-a716-446655440036',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'overdue',
    pricingTier: 'full',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440025',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440037',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'paid',
    pricingTier: 'full',
    amountPaid: 68.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440026',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440037',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'reduced',
    amountPaid: 17.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440027',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    feeId: '850e8400-e29b-41d4-a716-446655440037',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'reduced',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440028',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    feeId: '850e8400-e29b-41d4-a716-446655440038',
    quantity: 1,
    dueDate: new Date('2024-10-15'),
    status: 'paid',
    pricingTier: 'free',
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440029',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    feeId: '850e8400-e29b-41d4-a716-446655440038',
    quantity: 1,
    dueDate: new Date('2024-10-15'),
    status: 'pending',
    pricingTier: 'full',
    amountPaid: 36.00,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440030',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440039',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'paid',
    pricingTier: 'full',
    amountPaid: 55.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440031',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440039',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'reduced',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440032',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    feeId: '850e8400-e29b-41d4-a716-446655440039',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'full',
    amountPaid: 27.50,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440033',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    feeId: '850e8400-e29b-41d4-a716-446655440039',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'overdue',
    pricingTier: 'reduced',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440034',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    feeId: '850e8400-e29b-41d4-a716-446655440024',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'full',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440035',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    feeId: '850e8400-e29b-41d4-a716-446655440024',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'reduced',
    amountPaid: 23.75,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440036',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440025',
    quantity: 1,
    dueDate: new Date('2024-10-31'),
    status: 'paid',
    pricingTier: 'full',
    amountPaid: 75.00,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440037',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    feeId: '850e8400-e29b-41d4-a716-446655440025',
    quantity: 1,
    dueDate: new Date('2024-10-31'),
    status: 'pending',
    pricingTier: 'free',
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440038',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440026',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'reduced',
    amountPaid: 27.50,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440039',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    feeId: '850e8400-e29b-41d4-a716-446655440026',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'free',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440040',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    feeId: '850e8400-e29b-41d4-a716-446655440026',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'reduced',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440041',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    feeId: '850e8400-e29b-41d4-a716-446655440040',
    quantity: 1,
    dueDate: new Date('2024-10-31'),
    status: 'paid',
    pricingTier: 'full',
    amountPaid: 135.00,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440042',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    feeId: '850e8400-e29b-41d4-a716-446655440040',
    quantity: 1,
    dueDate: new Date('2024-10-31'),
    status: 'pending',
    pricingTier: 'reduced',
    amountPaid: 33.75,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440043',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440041',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'full',
    amountPaid: 44.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440044',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    feeId: '850e8400-e29b-41d4-a716-446655440041',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'free',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440045',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440042',
    quantity: 1,
    dueDate: new Date('2024-10-31'),
    status: 'paid',
    pricingTier: 'reduced',
    amountPaid: 22.50,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440046',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    feeId: '850e8400-e29b-41d4-a716-446655440042',
    quantity: 1,
    dueDate: new Date('2024-10-31'),
    status: 'pending',
    pricingTier: 'full',
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440047',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440043',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'paid',
    pricingTier: 'full',
    amountPaid: 52.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440048',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    feeId: '850e8400-e29b-41d4-a716-446655440043',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'free',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440049',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    feeId: '850e8400-e29b-41d4-a716-446655440043',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'reduced',
    amountPaid: 13.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440050',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440044',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'paid',
    pricingTier: 'reduced',
    amountPaid: 20.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440051',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    feeId: '850e8400-e29b-41d4-a716-446655440044',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'overdue',
    pricingTier: 'full',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440052',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    feeId: '850e8400-e29b-41d4-a716-446655440045',
    quantity: 1,
    dueDate: new Date('2024-10-31'),
    status: 'pending',
    pricingTier: 'free',
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440053',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    feeId: '850e8400-e29b-41d4-a716-446655440045',
    quantity: 1,
    dueDate: new Date('2024-10-31'),
    status: 'pending',
    pricingTier: 'reduced',
    amountPaid: 19.50,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440054',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440046',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'paid',
    pricingTier: 'full',
    amountPaid: 92.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440055',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440046',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'reduced',
    amountPaid: 23.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440056',
    studentId: '550e8400-e29b-41d4-a716-446655440003',
    feeId: '850e8400-e29b-41d4-a716-446655440047',
    quantity: 1,
    dueDate: new Date('2024-10-31'),
    status: 'pending',
    pricingTier: 'free',
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440057',
    studentId: '550e8400-e29b-41d4-a716-446655440004',
    feeId: '850e8400-e29b-41d4-a716-446655440047',
    quantity: 1,
    dueDate: new Date('2024-10-31'),
    status: 'paid',
    pricingTier: 'full',
    amountPaid: 105.00,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440058',
    studentId: '550e8400-e29b-41d4-a716-446655440001',
    feeId: '850e8400-e29b-41d4-a716-446655440048',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'full',
    amountPaid: 60.00,
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440059',
    studentId: '550e8400-e29b-41d4-a716-446655440002',
    feeId: '850e8400-e29b-41d4-a716-446655440048',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'pending',
    pricingTier: 'reduced',
    createdAt: new Date('2025-08-15'),
  },
  {
    id: '950e8400-e29b-41d4-a716-446655440060',
    studentId: '550e8400-e29b-41d4-a716-446655440005',
    feeId: '850e8400-e29b-41d4-a716-446655440048',
    quantity: 1,
    dueDate: new Date('2026-03-15'),
    status: 'overdue',
    pricingTier: 'reduced',
    createdAt: new Date('2025-08-15'),
  },
  generatePreAssessedFee(1001, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440003', 'full', 'pending'),
  generatePreAssessedFee(1002, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440004', 'full', 'paid', 1, 45.00),
  generatePreAssessedFee(1003, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440005', 'full', 'pending', 1, 60.00),
  generatePreAssessedFee(1004, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440016', 'full', 'pending'),
  generatePreAssessedFee(1005, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440022', 'full', 'paid', 1, 42.00),
  generatePreAssessedFee(1006, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440035', 'full', 'pending', 1, 87.50),
  generatePreAssessedFee(1007, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440036', 'full', 'paid', 1, 38.00),
  generatePreAssessedFee(1008, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440041', 'full', 'pending'),
  generatePreAssessedFee(1009, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440043', 'full', 'paid', 1, 52.00),
  generatePreAssessedFee(1010, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440046', 'full', 'pending', 1, 46.00),
  generatePreAssessedFee(1011, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440048', 'full', 'pending'),
  generatePreAssessedFee(1012, '550e8400-e29b-41d4-a716-446655440002', '850e8400-e29b-41d4-a716-446655440003', 'reduced', 'pending'),
  generatePreAssessedFee(1013, '550e8400-e29b-41d4-a716-446655440002', '850e8400-e29b-41d4-a716-446655440004', 'reduced', 'paid', 1, 22.50),
  generatePreAssessedFee(1014, '550e8400-e29b-41d4-a716-446655440002', '850e8400-e29b-41d4-a716-446655440005', 'reduced', 'pending'),
  generatePreAssessedFee(1015, '550e8400-e29b-41d4-a716-446655440002', '850e8400-e29b-41d4-a716-446655440016', 'reduced', 'pending', 1, 21.25),
  generatePreAssessedFee(1016, '550e8400-e29b-41d4-a716-446655440002', '850e8400-e29b-41d4-a716-446655440017', 'reduced', 'paid', 1, 27.50),
  generatePreAssessedFee(1017, '550e8400-e29b-41d4-a716-446655440002', '850e8400-e29b-41d4-a716-446655440022', 'reduced', 'pending'),
  generatePreAssessedFee(1018, '550e8400-e29b-41d4-a716-446655440002', '850e8400-e29b-41d4-a716-446655440023', 'reduced', 'paid', 1, 24.00),
  generatePreAssessedFee(1019, '550e8400-e29b-41d4-a716-446655440002', '850e8400-e29b-41d4-a716-446655440035', 'reduced', 'pending'),
  generatePreAssessedFee(1020, '550e8400-e29b-41d4-a716-446655440002', '850e8400-e29b-41d4-a716-446655440042', 'reduced', 'paid', 1, 22.50),
  generatePreAssessedFee(1021, '550e8400-e29b-41d4-a716-446655440002', '850e8400-e29b-41d4-a716-446655440044', 'reduced', 'pending'),
  generatePreAssessedFee(1022, '550e8400-e29b-41d4-a716-446655440002', '850e8400-e29b-41d4-a716-446655440048', 'reduced', 'overdue'),
  generatePreAssessedFee(1023, '550e8400-e29b-41d4-a716-446655440003', '850e8400-e29b-41d4-a716-446655440003', 'free', 'paid'),
  generatePreAssessedFee(1024, '550e8400-e29b-41d4-a716-446655440003', '850e8400-e29b-41d4-a716-446655440004', 'free', 'pending'),
  generatePreAssessedFee(1025, '550e8400-e29b-41d4-a716-446655440003', '850e8400-e29b-41d4-a716-446655440017', 'free', 'paid'),
  generatePreAssessedFee(1026, '550e8400-e29b-41d4-a716-446655440003', '850e8400-e29b-41d4-a716-446655440023', 'free', 'pending'),
  generatePreAssessedFee(1027, '550e8400-e29b-41d4-a716-446655440003', '850e8400-e29b-41d4-a716-446655440025', 'free', 'paid'),
  generatePreAssessedFee(1028, '550e8400-e29b-41d4-a716-446655440003', '850e8400-e29b-41d4-a716-446655440026', 'free', 'pending'),
  generatePreAssessedFee(1029, '550e8400-e29b-41d4-a716-446655440003', '850e8400-e29b-41d4-a716-446655440038', 'free', 'paid'),
  generatePreAssessedFee(1030, '550e8400-e29b-41d4-a716-446655440003', '850e8400-e29b-41d4-a716-446655440041', 'free', 'pending'),
  generatePreAssessedFee(1031, '550e8400-e29b-41d4-a716-446655440003', '850e8400-e29b-41d4-a716-446655440043', 'free', 'paid'),
  generatePreAssessedFee(1032, '550e8400-e29b-41d4-a716-446655440003', '850e8400-e29b-41d4-a716-446655440045', 'free', 'pending'),
  generatePreAssessedFee(1033, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440003', 'full', 'pending'),
  generatePreAssessedFee(1034, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440004', 'full', 'paid', 1, 45.00),
  generatePreAssessedFee(1035, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440005', 'full', 'pending', 1, 60.00),
  generatePreAssessedFee(1036, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440016', 'full', 'paid', 1, 85.00),
  generatePreAssessedFee(1037, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440024', 'full', 'pending'),
  generatePreAssessedFee(1038, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440036', 'full', 'paid', 1, 38.00),
  generatePreAssessedFee(1039, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440037', 'full', 'pending'),
  generatePreAssessedFee(1040, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440038', 'full', 'overdue'),
  generatePreAssessedFee(1041, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440039', 'full', 'paid', 1, 55.00),
  generatePreAssessedFee(1042, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440042', 'full', 'pending'),
  generatePreAssessedFee(1043, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440047', 'full', 'paid', 1, 105.00),
  generatePreAssessedFee(1044, '550e8400-e29b-41d4-a716-446655440005', '850e8400-e29b-41d4-a716-446655440003', 'reduced', 'pending'),
  generatePreAssessedFee(1045, '550e8400-e29b-41d4-a716-446655440005', '850e8400-e29b-41d4-a716-446655440004', 'reduced', 'paid', 1, 22.50),
  generatePreAssessedFee(1046, '550e8400-e29b-41d4-a716-446655440005', '850e8400-e29b-41d4-a716-446655440016', 'reduced', 'pending', 1, 21.25),
  generatePreAssessedFee(1047, '550e8400-e29b-41d4-a716-446655440005', '850e8400-e29b-41d4-a716-446655440017', 'reduced', 'paid', 1, 27.50),
  generatePreAssessedFee(1048, '550e8400-e29b-41d4-a716-446655440005', '850e8400-e29b-41d4-a716-446655440026', 'reduced', 'pending'),
  generatePreAssessedFee(1049, '550e8400-e29b-41d4-a716-446655440005', '850e8400-e29b-41d4-a716-446655440035', 'reduced', 'overdue'),
  generatePreAssessedFee(1050, '550e8400-e29b-41d4-a716-446655440005', '850e8400-e29b-41d4-a716-446655440039', 'reduced', 'paid', 1, 27.50),
  generatePreAssessedFee(1051, '550e8400-e29b-41d4-a716-446655440005', '850e8400-e29b-41d4-a716-446655440040', 'reduced', 'pending', 1, 33.75),
  generatePreAssessedFee(1052, '550e8400-e29b-41d4-a716-446655440005', '850e8400-e29b-41d4-a716-446655440043', 'reduced', 'paid', 1, 26.00),
  generatePreAssessedFee(1053, '550e8400-e29b-41d4-a716-446655440005', '850e8400-e29b-41d4-a716-446655440045', 'reduced', 'pending'),
  generatePreAssessedFee(1054, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440010', 'full', 'pending', 1, 32.50),
  generatePreAssessedFee(1055, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440012', 'full', 'paid', 1, 100.00),
  generatePreAssessedFee(1056, '550e8400-e29b-41d4-a716-446655440001', '850e8400-e29b-41d4-a716-446655440015', 'full', 'pending', 1, 100.00),
  generatePreAssessedFee(1057, '550e8400-e29b-41d4-a716-446655440002', '850e8400-e29b-41d4-a716-446655440010', 'reduced', 'paid', 1, 32.50),
  generatePreAssessedFee(1058, '550e8400-e29b-41d4-a716-446655440002', '850e8400-e29b-41d4-a716-446655440015', 'reduced', 'pending', 1, 50.00),
  generatePreAssessedFee(1059, '550e8400-e29b-41d4-a716-446655440003', '850e8400-e29b-41d4-a716-446655440010', 'free', 'paid'),
  generatePreAssessedFee(1060, '550e8400-e29b-41d4-a716-446655440003', '850e8400-e29b-41d4-a716-446655440015', 'free', 'pending'),
  generatePreAssessedFee(1061, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440010', 'full', 'pending'),
  generatePreAssessedFee(1062, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440012', 'full', 'paid', 1, 100.00),
  generatePreAssessedFee(1063, '550e8400-e29b-41d4-a716-446655440004', '850e8400-e29b-41d4-a716-446655440015', 'full', 'pending', 1, 100.00),
  generatePreAssessedFee(1064, '550e8400-e29b-41d4-a716-446655440005', '850e8400-e29b-41d4-a716-446655440010', 'reduced', 'paid', 1, 32.50),
  generatePreAssessedFee(1065, '550e8400-e29b-41d4-a716-446655440005', '850e8400-e29b-41d4-a716-446655440012', 'reduced', 'pending', 1, 25.00),
  generatePreAssessedFee(1066, '550e8400-e29b-41d4-a716-446655440005', '850e8400-e29b-41d4-a716-446655440015', 'reduced', 'overdue'),
];
